<template>
  <!--   <v-navigation-drawer v-if="$route.name !== 'Home'" class="primary darken-1 pa-4 d-none d-md-block" :clipped="clipped"
    fixed :permanent="permanent" app width="240"> -->
  <v-navigation-drawer v-if="$route.name !== 'Home'" class="primary darken-1 pa-4" :clipped="clipped" fixed
    :permanent="permanent" app width="240">
    <v-list nav flat>
      <v-list-item class="mb-4" v-for="(item, i) in menu" :key="i" :to="item.to" router exact link
        active-class="secondary--text text--lighten-1">
        <v-list-item-action class="mr-4">
          <v-icon size="22">{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content class="subtitle-1">
          <v-list-item-title v-text="item.title" style="white-space: normal !important;" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="guides" v-ripple @click="goToGuides">
      <div>
        <v-icon color="#8792D5">
          mdi-help-circle-outline
        </v-icon>
      </div>
      <div class="d-flex flex-column">
        <span class="help">Manual</span>
        <span class="help">do Usuário</span>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'DrawerNavigation',
  props: ['menu', 'permanent', 'clipped'],
  data: () => ({

  }),
  methods: {
    goToGuides() {
      this.$router.push('/Guides').catch(() => {})
    }
  }
}
</script>

<style scoped>
.nav-drawer2 {
  border: 2px solid red;
}

.guides {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: top;
  bottom: 0;
  cursor: pointer;
  padding: 1rem;
}


.help {
  margin-left: 6px;
  color: #8792D5;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>